"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSearchOptionsResponseDto = instanceOfSearchOptionsResponseDto;
exports.SearchOptionsResponseDtoFromJSON = SearchOptionsResponseDtoFromJSON;
exports.SearchOptionsResponseDtoFromJSONTyped = SearchOptionsResponseDtoFromJSONTyped;
exports.SearchOptionsResponseDtoToJSON = SearchOptionsResponseDtoToJSON;
exports.SearchOptionsResponseDtoToJSONTyped = SearchOptionsResponseDtoToJSONTyped;
var DigestOptionDto_1 = require("./DigestOptionDto");
/**
 * Check if a given object implements the SearchOptionsResponseDto interface.
 */
function instanceOfSearchOptionsResponseDto(value) {
    if (!('options' in value) || value['options'] === undefined)
        return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined)
        return false;
    return true;
}
function SearchOptionsResponseDtoFromJSON(json) {
    return SearchOptionsResponseDtoFromJSONTyped(json, false);
}
function SearchOptionsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'options': (json['options'].map(DigestOptionDto_1.DigestOptionDtoFromJSON)),
        'nextCursor': json['nextCursor'] == null ? undefined : json['nextCursor'],
        'hasMore': json['hasMore'],
    };
}
function SearchOptionsResponseDtoToJSON(json) {
    return SearchOptionsResponseDtoToJSONTyped(json, false);
}
function SearchOptionsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'options': (value['options'].map(DigestOptionDto_1.DigestOptionDtoToJSON)),
        'nextCursor': value['nextCursor'],
        'hasMore': value['hasMore'],
    };
}
